import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MenuItemEditModalComponent } from '../menu-item-edit-modal/menu-item-edit-modal.component'; // გზა სწორად მიუთითე

@Component({
  selector: 'app-menu-item',
  imports: [CommonModule, FormsModule, DragDropModule],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.css'
})
export class MenuItemComponent {
  @Input() item!: any;
  @Output() update = new EventEmitter<void>();

  showChildren = true;


  constructor(private modalService: NgbModal) {}
  
  // addChild() {
  //   const newChild = {
  //     id: Date.now(), // დროებითი ID
  //     title: 'ახალი ქვეპუნქტი',
  //     children: [] as any[]
  //   };
  //   this.item.children.push(newChild);
  //   this.update.emit();
  // }

  deleteItem() {
    // პირდაპირ მშობელიდან უნდა წაიშალოს
  }

  dropChild(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.item.children, event.previousIndex, event.currentIndex);
    this.update.emit();
  }

  openEditModal() {
    const modalRef = this.modalService.open(MenuItemEditModalComponent, { size: 'md' });
    modalRef.componentInstance.menuItem = { ...this.item }; // კოპია, რომ პირდაპირ არ შეცვალოს

    modalRef.result.then((result: any) => {
      if (result) {
        this.item.menutitle = result.menutitle;
        this.item.visibility = result.visibility;
        this.update.emit(); // მშობელისთვის ცვლილების გადაცემა
      }
    }).catch(() => {});
  }

}
